import styled from "styled-components"

export const SignatureDiv = styled.div`
  right: 0;
  margin-top: 2rem;
  position: relative;
  display: flex;
  justify-content: end;
`

export const SignatureImg = styled.img`
  width: 15rem;
`

export const SignatureText = styled.div`
  display: flex;
  font-weight: 500;
  text-align: center;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;

  span{
    &.english{
      color: #00C0D5;
      font-weight: 400;
      font-style: italic;
    }
  }
`